import handleVoucherNo from "@/services/modules/refNumber";

export const JOURNAL_VOUCHER = 'journal_voucher';
export const RECEIPT_VOUCHER = 'receipt_voucher';
export const PAYMENT_VOUCHER = 'payment_voucher';
export const CONTRA_VOUCHER = 'contra_voucher';

function formatVoucher(str) {
	let voucherArr = str.split('-');
	let serial = voucherArr[voucherArr.length - 1];
	voucherArr.pop()
	let prefix = voucherArr.join('-');
	return {
		prefix,
		serial
	}
}

export function generateQuery(companyId, voucher_type, txn_type) {
	return `?company_id=${companyId}&voucher_type=${voucher_type}&txn_type=${txn_type}`
}

export function editVoucherNumber(voucherNo) {
	const {prefix, serial} = formatVoucher(voucherNo)
	
	return {
		 'prefix' : prefix,
		 'serial' : serial,
	 }
}